import { defineComponent as _defineComponent } from 'vue'
import Action from '@/components/atoms/action/Action.vue';
import ArrowLeftIcon from '@/icons/ArrowLeftIcon.vue';
import { getCurrentInstance } from 'vue';

interface PageHeaderProps {
    title: string;
    prev?: () => void;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PageHeader',
  props: {
    title: null,
    prev: null
  },
  setup(__props: any) {

const props = __props as {
    title: string;
    prev?: () => void;
};



const instance = getCurrentInstance();
const proxy = instance && instance.proxy as any;


const goBack = () => {
    props.prev ? props.prev() : proxy.$router.go(-1);
};

return { __sfc: true,props, instance, proxy, goBack, Action, ArrowLeftIcon }
}

})